import { render, staticRenderFns } from "./DialogEventGroup.vue?vue&type=template&id=572efdcf&"
import script from "./DialogEventGroup.vue?vue&type=script&lang=js&"
export * from "./DialogEventGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports